import { Button, ButtonIcon, ButtonText } from "@/components/ui/button";
import { ChevronDownIcon, Icon } from "@/components/ui/icon";
import { HStack } from "@/components/ui/hstack";
import { VStack } from "@/components/ui/vstack";
import { Select, SelectBackdrop, SelectContent, SelectDragIndicator, SelectDragIndicatorWrapper, SelectIcon, SelectInput, SelectItem, SelectPortal, SelectTrigger } from "@/components/ui/select";
import {
    Popover,
    PopoverBackdrop,
    PopoverContent,
} from "@/components/ui/popover";
import {MaterialCommunityIcons} from "@expo/vector-icons";
import {useEffect, useState} from "react";
import {Text} from "@/components/ui/text";


export default function LanguageButton({ filterValue, setFilterValue=(values)=>{}, onDelete=()=>{}, openOnMount=false }) {

    const [isOpen, setIsOpen] = useState(false)
    const [value, setValue] = useState(null)
    const languages = [
        {key: "German", label: "Deutsch"},
        {key: "English", label: "Englisch"},
        {key: "French", label: "Französisch"},
        {key: "Italian", label: "Italienisch"},
        {key: "Russian", label: "Russisch"},
        {key: "Dutch", label: "Niederländisch"},
        {key: "Polish", label: "Polnisch"},
        {key: "Turkish", label: "Türkisch"},
    ]

    useEffect(() => {
        setIsOpen(openOnMount)
    }, [])

    useEffect(() => {
        console.log("Languagebutton value")
        console.log(filterValue)
        setValue(filterValue)
    }, [filterValue, isOpen])

    useEffect(() => {
        console.log("Value")
        console.log(languages.find(l => l.key === value)?.label)
    }, [value])

    return (<Popover
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onOpen={() => setIsOpen(true)}
        placement="top left"
        offset={10}
        trigger={({ ...triggerProps }) => (
            <Button
                {...triggerProps}
                size="sm"
                className={`group w-9 h-9 rounded-full items-center justify-center bg-transparent border border-primary-900
                    overflow-hidden ${filterValue ? 'bg-primary-900' : 'bg-transparent'}`}
            >
                <ButtonIcon
                    as={MaterialCommunityIcons}
                    name="translate"
                    size={18}
                    className={`${filterValue ? 'text-white' : 'text-primary-900'} group-hover:text-white`}
                />
            </Button>
        )}
    >
        <PopoverBackdrop className="bg-transparent" />

        <PopoverContent className="bg-white p-3.5 w-auto gap-3 rounded-r-md shadow-md">
            <Text className="font-semibold">Sprache</Text>

            <Select
                initialLabel={value ? languages.find((l) => l.key === value)?.label : null}
                selectedValue={languages.find((l) => l.key === value)?.key}
                onValueChange={(v) => {
                    console.log("Set value", v);
                    setValue(v);
                }}
            >
                <SelectTrigger className="border border-secondary-300 rounded-md h-9 px-0 flex-row items-center justify-between">
                    <SelectInput placeholder="Wählen..." />
                    <SelectIcon as={ChevronDownIcon} className="mr-1" />
                </SelectTrigger>

                <SelectPortal>
                    <SelectBackdrop />
                    <SelectContent>
                        <SelectDragIndicatorWrapper>
                            <SelectDragIndicator />
                        </SelectDragIndicatorWrapper>

                        {languages.map((language) => (
                            <SelectItem
                                key={language.key}
                                value={language.key}
                                label={language.label}
                            />
                        ))}
                    </SelectContent>
                </SelectPortal>
            </Select>

            <HStack className="flex-row justify-between gap-2">
                <Button
                    onPress={() => {
                        setFilterValue(value);
                        setIsOpen(false);
                    }}
                    className="flex-1 h-[34px] bg-primary-900 px-7 rounded-md"
                >
                    <ButtonText className="text-white">Auswählen</ButtonText>
                </Button>

                <Button
                    onPress={onDelete}
                    className="h-[34px] bg-error-600 px-3 rounded-md"
                >
                    <ButtonIcon
                        as={MaterialCommunityIcons}
                        name="trash-can"
                        className="text-white"
                        size={18}
                    />
                </Button>
            </HStack>
        </PopoverContent>
    </Popover>)

}
